module.exports = __webpack_public_path__ + "static/media/Panic Button.6d53bcdc.svg";